<template>
  <div class="detail-card">
    <div class="detail-card-head">
      <div class="detail-card-head_title flex-1">标讯订阅列表</div>
      <div v-if="subscribeNoticeList.length > 0" class="detail-card-head-right">
        <a-button
          style="height: auto; color: #CB9D46"
          type="link"
          @click="toBiddogSubscription"
        >查看更多</a-button>
      </div>
    </div>
    <div class="detail-card-body">
      <div v-if="subscribeNoticeList.length > 0" class="notice-list list-wrap">
        <notice-list-item
          v-for="item in subscribeNoticeList"
          :key="item.id"
          class="notice-list-item"
          :notice="getNotice(item)"
        />
      </div>
      <div v-else class="empty-wrap list-wrap">
        <img
          style="width: 100px; height: 100px"
          :src="
            require('@/assets/images/personal-center/vip-home/empty-subscription.png')
          "
          alt=""
        />
        <div class="empty-tip">
          未收到标讯？立即前往标讯订阅-<a-button
            type="link"
            class="vip-color"
            style="height: auto; padding: 0"
            @click="toBiddogSubscribeSet"
          >订阅管理</a-button>设置关键词
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 组件
import NoticeListItem from '@/components/ValueAddedService/NoticeListItem'
// 工具
import { toBiddogPage } from '@/utils/utils'
// 接口
import {
  getLastSubscribeConfigApi,
  getSubscribeListApi
} from '@/api/value-added-service'
// 字典
import { noticeResourceDict } from '@/dictionary/common'

export default {
  name: 'VipSubscription',

  components: { NoticeListItem },

  data() {
    return {
      // 最新的订阅设置
      subscribeConfig: {},
      // 订阅的公告列表
      subscribeNoticeList: []
    }
  },

  computed: {
    // 是否未设置订阅
    configEmpty() {
      return !this.subscribeConfig.subscribeId
    }
  },

  created() {
    this.getSubscribeConfig()
  },

  methods: {
    /**
     * 前往标前狗商机订阅页
     */
    toBiddogSubscription() {
      toBiddogPage('/subscription/list')
    },

    /**
     * 获取用户最新的订阅配置信息，确定用户是否设置了订阅
     */
    getSubscribeConfig() {
      getLastSubscribeConfigApi()
        .then(res => {
          this.subscribeConfig = res.data || {}
          if (!this.configEmpty) {
            this.getSubscribeNoticeList()
          }
        })
        .catch(err => {
          console.error('获取订阅配置信息失败', err)
          if (err.data?.message) this.$message.error(err.data.message)
        })
    },

    /**
     * 查询订阅列表
     */
    getSubscribeNoticeList() {
      getSubscribeListApi({ page: 1, size: 5 })
        .then(res => {
          this.subscribeNoticeList = res.data.records || []
        })
        .catch(err => {
          console.error('查询订阅列表失败', err)
          if (err.data?.message) this.$message.error(err.data.message)
        })
    },

    getNotice(item) {
      // 需要根据sourceNoticeId区分公告来源
      const noticeSource = item.messageInfo.sourceNoticeId.split('_')[0]
      const noticeId =
        noticeSource === noticeResourceDict.JCZH.value.toString()
          ? item.messageInfo.sourceNoticeId.split('_')[1]
          : item.messageInfo.noticeId

      return {
        noticeId: noticeId,
        title: item.messageInfo?.noticeTitle,
        province: item.messageInfo?.province,
        bidMethod: item.messageInfo?.bidMethod,
        budget: item.messageInfo?.budget,
        publishTime: item.messageInfo?.publishTime,
        resource: noticeSource
      }
    },

    /**
     * 前往标前狗订阅管理页
     */
    toBiddogSubscribeSet() {
      toBiddogPage('/subscription/set')
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-card {
  background-color: $white-color;
  border-radius: 4px;
  padding: 20px 24px;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  .detail-card-head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .detail-card-head_title {
      font-size: 16px;
      color: $text-color;
      @include text-bold;

      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 16px;
        background: $member-fifth-color;
        margin-right: 6px;
        vertical-align: -12%;
      }
    }

    .detail-card-head_sub {
      font-size: 12px;
      color: $text-third-color;
      margin-left: 8px;
    }
  }
}

.list-wrap {
  border-top: 1px solid $info-fourth-color;
}

.vip-color {
  color: #cb9d46;
}

.empty-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 110px 0 140px;

  .empty-tip {
    text-align: center;
    color: $text-second-color;
    margin-top: 16px;
    line-height: 24px;
  }
}
</style>
